import * as faceapi from '@vladmandic/face-api/dist/face-api.esm.js';
import {PipelineResultImpl} from "./PipelineResult";
import {isMobile, MAX_RESOLUTION_HEIGHT} from "../hooks/useLiveness";
import {createElementImage, getVideoRatio, initDevice} from "../../../../utils";
import {
    documentValidator,
    validateImage,
    validateImageNormal,
    validateSignature
} from "../../../../services/documentValidator";
import {onReportEvent} from "../../../cardCapture/utils";
import {EVENT_TRACER} from "../../../../constants";
import {SDK_EVENT_KEYS} from "../../../../utils/logService";



function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result.split(',')[1]); // Obtiene solo la parte base64
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async function base64ToBlob(dataURL) {
    try {
      const [header, base64String] = dataURL.split(',');
      const mimeType = header.match(/:(.*?);/)[1];
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      return new Blob([byteArray], { type: mimeType });
    } catch (error) {
      console.error('Error al convertir Base64 a Blob:', error);
      throw error;
    }
  }

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});

const cv = window.cv;
export class Detector {
    static croppedImage = true
    static imageNumber = 0
    static processId = ''
    static hasResponseToValidation = false
    static imagesSaved = []
    static base64Saved = []

    constructor(stream, isMobile, modelPath, croppedImage, processId, spf) {
        this.probabilityThreshold = 50;
        this.counterSuccessfulResults = 0;
        this.MAX_FPS_DETECTION = 500;
        this.rendering = {
            now: 0,
            elapsed: 0,
            then: 0,
        };
        this.MAX_NUMBER_FACES = 1;
        this.MAX_ANGLE_TURN_HEAD = 30;
        this.MIN_FACE_SIZE_FOR_MOBILE = 224;
        this.MIN_FACE_SIZE_FOR_DESKTOP = 350;
        this.MIN_OCCUPIED_SPACE_FOR_DESKTOP = 15;
        this.MIN_OCCUPIED_SPACE_FOR_MOBILE = 15;
        this.X_OFFSET_FROM_FRAME = 15;
        this.Y_OFFSET_FROM_FRAME = 5;
        this.DEFAULT_NUMBER_SUCCESSFUL_RESULTS_FOR_AUTO_CAPTURING = 1;
        this.videoRatio = 1;
        this.showDetectedFace = false;
        this.headTurnCounter = 0;
        this.counterSuccessfulHeadTurns = 0;
        this.stream = stream;
        this.isMobile = isMobile;
        this.modelPath = modelPath;
        this.croppedImage = croppedImage
        this.processId = processId
        this.spf = spf
    }
    setProbabilityThreshold(val) {
        this.probabilityThreshold = val;
    }
    static getInstance(stream, isMobile, modelPath, croppedImage, processId, spf) {
        if (!Detector.instance) {
            Detector.instance = new Detector(stream, isMobile, modelPath, croppedImage, processId, spf);
        }
        return Detector.instance;
    }
    updateHtmlElements(videoElement) {
        this.videoElement = videoElement;
    }
    static async initDetector(modelPath) {
        /*await faceapi.tf.setBackend(this.BACKEND);
        await faceapi.tf.enableProdMode();
        await faceapi.tf.ENV.set('DEBUG', false);
        await faceapi.tf.ready();*/
        await this.loadingModels(modelPath);
        if (!cv)
            console.error("open cv not found");

    }
    static async loadingModels(modelPath) {
        if (!this.modelsLoaded()) {
            await faceapi.nets.tinyFaceDetector.load(modelPath);
            await faceapi.nets.faceLandmark68TinyNet.load(modelPath);
        }
    }
    static modelsLoaded() {
        return true// faceapi.nets.tinyFaceDetector.isLoaded && faceapi.nets.faceLandmark68TinyNet.isLoaded;
    }
    static async warmingUpModels() {
        // const image = new Image();
        // image.src = base64Photo;
        // await this.detectAllFaces(image);
    }
    static async resizeBase64(base64, width, height, quality, changeQuality = true) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                if (changeQuality) {
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
                }

                canvas.toBlob(
                    (blob) => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            resolve({
                                blob,
                                base64: reader.result
                            });
                        };
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    },
                    'image/jpeg',
                    changeQuality ? quality : 1
                );
            };
            img.onerror = reject;
            img.src = base64;
        });
    }
    static async detectAllFaces(videoSrc, croppedImage, config, spf) {
        let result = {
            croppedImage: '',
            originalImage: '',
            faces: [],
            error: null,
            size: {
                original: {
                    width: 0,
                    height: 0,
                },
                cropped: {
                    width: 0,
                    height: 0,
                }
            }
        };
        if (this.imageNumber < 4) {

            try {
                if (this.imageNumber === 0) {
                    onReportEvent(SDK_EVENT_KEYS.InitDetection).catch();
                }
                const width = videoSrc.videoWidth;
                const height = videoSrc.videoHeight;

                // Para responder, imagen grande
                const originalCanvas = document.createElement('canvas');
                originalCanvas.width = width;
                result.size.original.width = width
                originalCanvas.height = height;
                result.size.original.height = height
                const contextOriginal = originalCanvas.getContext('2d');
                contextOriginal.drawImage(videoSrc, 0, 0, originalCanvas.width, originalCanvas.height);
                onReportEvent(SDK_EVENT_KEYS.CaptureFrame).catch();
                const originalImage = originalCanvas.toDataURL('image/jpeg', 0.9);
                if (this.imageNumber === 0) {
                    onReportEvent(SDK_EVENT_KEYS.FrameToBase64).catch();
                    // onReportEvent(EVENT_TRACER.SERVICE.CreateBase64Image, "Iniciando proceso de creación de imagenes").catch();
                }
                const blobImage = await base64ToBlob(originalImage);

                this.imagesSaved.push(blobImage)
                this.base64Saved.push(originalImage)
                this.imageNumber++;
                this.hasResponseToValidation = false
                if (this.imageNumber === 4) {
                    // onReportEvent(EVENT_TRACER.SERVICE.Base64ImageCreated, "Finalizo proceso de creación de imagenes").catch();
                }

            }
            catch (e) {
                console.log('errrrororor', e)
                // bug in face api with canvas context 2d
            }
            return
        }
        if (this.hasResponseToValidation) {
            return { result: null, response: null };
        }
        this.hasResponseToValidation = true
        let response;

        try {
            onReportEvent(SDK_EVENT_KEYS.FrameSend).catch()
            // onReportEvent(EVENT_TRACER.SERVICE.SendingImageToValidate, "Enviando imagenes al backend").catch();

            response = await validateImage(this.imagesSaved, this.imageNumber, config.processId, config.deviceType, config.urlServiceLiveness, spf)
            onReportEvent(SDK_EVENT_KEYS.FrameSuccess)
            // onReportEvent(EVENT_TRACER.SERVICE.SendingImageToValidateFinish, `Respuesta del backend (Is alive: ${response?.data?.isAlive})`).catch();

            result.originalImage = response?.BestImage
            result.croppedImage = response?.BestImage
            result.error = response?.data?.ErrorCode || null
            result.faces = true
            result.isAlive = response?.data?.isAlive || false
            this.imageNumber = 0;
            this.imagesSaved = [];
            this.hasResponseToValidation = false;
            return { result, response };
        } catch (e) {
            this.imageNumber = 0;
            this.imagesSaved = [];
            this.hasResponseToValidation = false;
            onReportEvent(SDK_EVENT_KEYS.FrameError, {error: e.message}).catch()
            return {result: null, response: null}
        }
    }
    static async detectAllFacesOtherClients(videoSrc, croppedImage, config) {
        if (this.hasResponseToValidation) {
            return { result: null, response: null };
        }
        this.hasResponseToValidation = true
        let result = {
            croppedImage: '',
            originalImage: '',
            faces: [],
            error: null,
            size: {
                original: {
                    width: 0,
                    height: 0,
                },
                cropped: {
                    width: 0,
                    height: 0,
                }
            }
        };

        try {
            onReportEvent(SDK_EVENT_KEYS.InitDetection).catch();
            // onReportEvent(EVENT_TRACER.SERVICE.InitDetection, "Iniciando detección").catch();
            const width = videoSrc.videoWidth;
            const height = videoSrc.videoHeight;

            // Para responder, imagen grande
            const originalCanvas = document.createElement('canvas');
            originalCanvas.width = width;
            result.size.original.width = width
            originalCanvas.height = height;
            result.size.original.height = height
            const contextOriginal = originalCanvas.getContext('2d');
            contextOriginal.drawImage(videoSrc, 0, 0, originalCanvas.width, originalCanvas.height);
            onReportEvent(SDK_EVENT_KEYS.CaptureFrame).catch();

            const originalImage = originalCanvas.toDataURL('image/jpeg', 0.9);
            onReportEvent(SDK_EVENT_KEYS.FrameToBase64).catch();
            // onReportEvent(EVENT_TRACER.SERVICE.CreateBase64Image, "Iniciando proceso de creación de base64").catch();

            const blobImage = await base64ToBlob(originalImage);
            // onReportEvent(EVENT_TRACER.SERVICE.Base64ImageCreated, "Base64 de la imagen creada").catch();

            let response;
            try {
                onReportEvent(SDK_EVENT_KEYS.FrameSend).catch()
                // onReportEvent(EVENT_TRACER.SERVICE.SendingImageToValidate, "Enviando imagen al backend").catch();

                response = await validateImageNormal(blobImage, this.imageNumber, config.processId, config.deviceType, config.urlServiceLiveness)
                onReportEvent(SDK_EVENT_KEYS.FrameSuccess).catch();
                // onReportEvent(EVENT_TRACER.SERVICE.SendingImageToValidateFinish, `Respuesta del backend (Is alive: ${response?.data?.isAlive})`).catch();

            } catch (error) {
                console.log("Error al validar imagen: ", error)
                onReportEvent(SDK_EVENT_KEYS.FrameError, {error: error.message}).catch()
                response = {}
            }
            this.imageNumber++;
            this.hasResponseToValidation = false
            result.originalImage = originalImage
            result.croppedImage = originalImage
            result.error = response?.data?.ErrorCode || null
            result.faces = true
            result.isAlive = response?.data?.isAlive || false
            return {result, response};
        }
        catch (e) {
            console.log('errrrororor', e)
            // bug in face api with canvas context 2d
        }
    }
    async startDetector() {
        if (!this.videoElement)
            throw Error("Video element not found");
        if (this.videoElement.clientWidth === 0)
            throw Error("Video element too small");
        this.rendering.then = Date.now();
        this.counterSuccessfulResults = 0;
        this.updateForIos();
        this.videoRatio = getVideoRatio(this.videoElement);
        this.requestAnimationFrame = requestAnimationFrame(() => this.detection());
    }
    stopDetector() {
        if (this.requestAnimationFrame) {
            // @ts-ignore
            cancelAnimationFrame(this.requestAnimationFrame); // TODO
            this.requestAnimationFrame = undefined;
            if (this.innerCanvas)
                this.innerCanvas.remove();
            this.innerCanvas = undefined;
        }
    }
    updateForIos() {
        const device = initDevice();
        if (device.isIos) {
            this.DEFAULT_NUMBER_SUCCESSFUL_RESULTS_FOR_AUTO_CAPTURING = 1;
            this.MAX_FPS_DETECTION = 1000 / 2;
            Detector.isIos = true;
        }
    }
    async detection() {
        this.requestAnimationFrame = requestAnimationFrame(() => this.detection());
        this.rendering.now = Date.now();

        this.rendering.elapsed = this.rendering.now - this.rendering.then;
        if (this.rendering.elapsed > this.MAX_FPS_DETECTION) {
            this.rendering.then = this.rendering.now - (this.rendering.elapsed % this.MAX_FPS_DETECTION);
            const projectName = params.projectName || 'default'

            const porvenirProjects = ['test'] // ['PorvenirSTG', 'Porvenir', 'PorvenirQA']
            if (this.spf) {
                const { result, response } = await Detector.detectAllFaces(this.videoElement, this.croppedImage, this.processId, this.spf);
                if (result) {
                    if (result?.isAlive) {
                        onReportEvent(SDK_EVENT_KEYS.IsAlive).catch();
                        onReportEvent(SDK_EVENT_KEYS.EndDetection).catch();
                        this.counterSuccessfulResults++;
                        this.autoCapturing({images: {cropped: result.originalImage, original: result.originalImage, size: result.size}, response});
                    }
                    else {
                        onReportEvent(SDK_EVENT_KEYS.IsNotAlive).catch();
                        onReportEvent(SDK_EVENT_KEYS.EndDetection).catch();
                        this.counterSuccessfulResults = 0;
                        this.stream.returnErrors(result.error);
                    }
                }
            } else {
                const { result, response } = await Detector.detectAllFacesOtherClients(this.videoElement, this.croppedImage, this.processId);
                if (result) {
                    if (result?.isAlive) {
                        onReportEvent(SDK_EVENT_KEYS.IsAlive).catch();
                        onReportEvent(SDK_EVENT_KEYS.EndDetection).catch();
                        this.counterSuccessfulResults++;
                        this.autoCapturing({images: {cropped: result.originalImage, original: result.originalImage, size: result.size}, response});
                    }
                    else {
                        onReportEvent(SDK_EVENT_KEYS.IsNotAlive).catch();
                        onReportEvent(SDK_EVENT_KEYS.EndDetection).catch();
                        this.counterSuccessfulResults = 0;
                        this.stream.returnErrors(result.error);
                    }
                }

            }


            // const faceErrors = await this.checkDetectedFaceOnError(detectionResult.faces);

        }
    }
    async checkDetectedFaceOnError(detectedFaces) {
        const detectionFacesForSize = faceapi.resizeResults(detectedFaces, {
            width: this.videoElement.videoWidth,
            height: this.videoElement.videoHeight,
        });
        const pipelineResults = new PipelineResultImpl();
        const faceDetection = this.checkNumberFaces(detectionFacesForSize);
        pipelineResults["FACE_NOT_FOUND"] = !faceDetection && detectionFacesForSize.length === 0;
        pipelineResults["TOO_MANY_FACES"] = !faceDetection && detectionFacesForSize.length > this.MAX_NUMBER_FACES;
        if (faceDetection) {
            if (cv)
                // pipelineResults["FACE_ANGLE_TOO_LARGE"] = !this.checkHeadRotation(detectionFacesForSize);
            pipelineResults["PROBABILITY_TOO_SMALL"] = !this.checkProbability(detectionFacesForSize);
            pipelineResults["FACE_TOO_SMALL"] = !this.checkFaceSize(detectionFacesForSize);
            pipelineResults["FACE_CLOSE_TO_BORDER"] = !this.checkFaceIndent(detectionFacesForSize);
        }
        return pipelineResults;
    }
    autoCapturing(images) {
        if (Detector.debug) console.info(this.counterSuccessfulResults);
        if (this.counterSuccessfulResults >= this.DEFAULT_NUMBER_SUCCESSFUL_RESULTS_FOR_AUTO_CAPTURING) {
            this.stream.autoCapturing(images);
            this.counterSuccessfulResults = 0;
        }
    }
    // @ts-ignore TODO
    checkNumberFaces(detectionResult) {
        return detectionResult.length === this.MAX_NUMBER_FACES;
    }
    // @ts-ignore TODO
    checkProbability(detectionResult) {
        const score = detectionResult[0].detection.score;
        return score > +this.probabilityThreshold / 100;
    }
    // @ts-ignore TODO
    checkFaceSize(detectionResult) {
        const faceBox = detectionResult[0].detection.box;
        const { width, height, area } = faceBox;
        const { imageHeight, imageWidth } = detectionResult[0].detection;
        const occupiedSize = 100 / ((imageHeight * imageWidth) / area);
        const minSide = Math.min(width / this.videoRatio, height / this.videoRatio);
        return (minSide > (this.isMobile ? this.MIN_FACE_SIZE_FOR_MOBILE : this.MIN_FACE_SIZE_FOR_DESKTOP) &&
            occupiedSize > (this.isMobile ? this.MIN_OCCUPIED_SPACE_FOR_MOBILE : this.MIN_OCCUPIED_SPACE_FOR_DESKTOP));
    }
    // @ts-ignore TODO
    checkFaceIndent(detectionResult) {
        const faceBox = detectionResult[0].detection.box;
        const { imageHeight, imageWidth } = detectionResult[0].detection;
        const { top, left, bottom, right } = faceBox;
        const topIndent = top;
        const leftIndent = left;
        const rightIndent = imageWidth - right;
        const bottomIndent = imageHeight - bottom;
        return !(topIndent < this.Y_OFFSET_FROM_FRAME ||
            leftIndent < this.X_OFFSET_FROM_FRAME ||
            rightIndent < this.X_OFFSET_FROM_FRAME ||
            bottomIndent < this.Y_OFFSET_FROM_FRAME);
    }
    // @ts-ignore TODO
    checkHeadRotation(detectionResult) {
        /*const temporaryCanvas = document.createElement("canvas");
        const dims = faceapi.matchDimensions(temporaryCanvas, this.videoElement, true);
        temporaryCanvas.remove();
        const headPosition = new HeadPosition(detectionResult[0].landmarks.positions, dims);
        let angles = [0, 0, 0];
        try {
            angles = headPosition.estimateHeadPose();
        }
        catch (e) {
            // some error with open cv
        }
        if (angles[2] > this.MAX_ANGLE_TURN_HEAD || angles[2] * -1 > this.MAX_ANGLE_TURN_HEAD) {
            this.headTurnCounter++;
        }
        else {
            this.counterSuccessfulHeadTurns++;
            if (this.counterSuccessfulHeadTurns >= 5) {
                this.headTurnCounter = 0;
                this.counterSuccessfulHeadTurns = 0;
            }
        }
        return this.headTurnCounter <= 1;*/
    }
    drawFaces(data) {
        console.log(data);
        if (!this.innerCanvas) {
            this.createCanvasForDrawingMask(this.videoElement);
        }
        const canvas = this.innerCanvas;
        if (!canvas)
            return console.error("no canvas for drawing");
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return;

    }
    createCanvasForDrawingMask(video) {
        this.innerCanvas = document.createElement("canvas");
        this.innerCanvas.className = "canvas-on-video";
        this.innerCanvas.width = video.videoWidth;
        this.innerCanvas.height = video.videoHeight;
        this.videoElement.after(this.innerCanvas);
        if (this.innerCanvas.offsetWidth) {
            this.innerCanvas.setAttribute("style", `margin-left:${-(this.innerCanvas.offsetWidth / 2)}px; margin-top: ${-(this.innerCanvas.offsetHeight / 2)}px;`);
        }
    }
}
Detector.tinyFaceDetectorOptions = new faceapi.TinyFaceDetectorOptions({ inputSize: 192 });
Detector.BACKEND = 'webgl';
Detector.debug = false;
